/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import {
  toSignupRequest,
  toLoginRequest,
  toAuthProps,
  toChangeEmailRequest,
  toChangePasswordRequest,
  toForgetRequest,
  toActivateRequest,
  toPasswordRequest,
  toEmailRequest
} from './translator/auth'
import { toUserProps, toProfileRequest } from './translator/user'
import {
  PostSignup,
  PostLogin,
  GetRefresh,
  PutChangeEmail,
  PostForget,
  PutChangePassword,
  PostIdentification,
  PostLogout,
  GetMe,
  PutProfile,
  PutProfileMedia,
  PostEmail,
  PostPassword,
  PostActivate,
  PostWithdraw,
  PostRemove
} from '@/infrastructure/network/Monitaro/requests/auth'
import { IAccountProps } from '@/entities/Account'
import { IUserDataProps, IUserProps } from '@/entities/User'

export default class Auth extends MonitaroGatewayBase {
  async PostSignup(params: IAccountProps) {
    const { userId } = await this.apiClient.request(new PostSignup(toSignupRequest(params)))
    return userId
  }

  async PostLogin(params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PostLogin(toLoginRequest(params)))
    return toAuthProps(auth)
  }

  async GetRefresh() {
    const { auth } = await this.apiClient.request(new GetRefresh())
    return toAuthProps(auth)
  }

  async PutChangeEmail(id: string, params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PutChangeEmail(id, toChangeEmailRequest(params)))
    return toAuthProps(auth)
  }

  async PostForget(params: IAccountProps) {
    const { forget } = await this.apiClient.request(new PostForget(toForgetRequest(params)))
    return forget
  }

  async PutChangePassword(id: string, params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PutChangePassword(id, toChangePasswordRequest(params)))
    return toAuthProps(auth)
  }

  async PostIdentification(user: string, params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PostIdentification(user, toActivateRequest(params)))
    return toAuthProps(auth)
  }

  async PostActivate() {
    const { auth } = await this.apiClient.request(new PostActivate())
    return toAuthProps(auth)
  }

  async PostLogout() {
    const { logout } = await this.apiClient.request(new PostLogout())
    return logout
  }

  async GetMe() {
    const { user } = await this.apiClient.request(new GetMe())
    return toUserProps(user)
  }

  async PutProfile(params: IUserProps) {
    const { user } = await this.apiClient.request(new PutProfile(toProfileRequest(params)))
    return toUserProps(user)
  }

  async PutProfileMedia(params: IUserDataProps) {
    const { user } = await this.apiClient.request(new PutProfileMedia(params))
    return toUserProps(user)
  }

  async PostEmail(params: IAccountProps) {
    const { forget } = await this.apiClient.request(new PostEmail(toEmailRequest(params)))
    return forget
  }

  async PostPassword(params: IAccountProps) {
    const { auth } = await this.apiClient.request(new PostPassword(toPasswordRequest(params)))
    return toAuthProps(auth)
  }

  async PostWithdraw(exec: boolean) {
    const { user } = await this.apiClient.request(new PostWithdraw(exec))
    return toUserProps(user)
  }

  async PostRemove() {
    const { user } = await this.apiClient.request(new PostRemove())
    return toUserProps(user)
  }
}
